(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SectorCategory', SectorCategory);

    SectorCategory.$inject = ['$resource'];

    function SectorCategory ($resource) {
        var resourceUrl =  'api/sector-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
